const privileges = {
  postToMlog: "postToMlog", // allows posting data to mlog
};

export default privileges;
